import {
  Table,
  TableContainer,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
} from '@chakra-ui/react';
import { useState, useEffect } from 'react';
// Custom components
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ReactPaginate from 'react-paginate';
import {
  allBranchDetail,
  getFollowup,
  viewLead,
  allCounselorDetail,
  updateLead,
} from '../../../redux/actions/Files.action';
import userPhoto from '../../../assets/img/user.png';
import moment from 'moment';
import { FaEdit } from 'react-icons/fa';
import { MdCampaign, MdDescription, MdWhatsapp } from 'react-icons/md';
import FileUpdate from 'views/admin/lead/FileUpdate';
import { IoSearchOutline } from 'react-icons/io5';
import { Button, Form } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import { getMessage, getSetting } from '../../../redux/actions/Setting.action';
import { FaPhone } from 'react-icons/fa6';
// import "./styles.css"
import { FaCalendarPlus, FaRegClock, FaUser } from 'react-icons/fa';
import { MdDateRange, MdDelete, MdLocationOn, MdComment } from 'react-icons/md';
import { FaWpforms } from 'react-icons/fa6';
import { FiTarget } from 'react-icons/fi';
import { toast } from 'react-toastify';

// Add responsive styles
// const responsiveStyles = `
//   /* Styles for all screen sizes */
//   .mobile-only-button {
//     display: none !important;
//   }

//   @media only screen and (max-width: 768px) {
//     .mobile-only-button {
//       display: inline-flex !important;
//     }
//   }
// `;
const responsiveStyles = `
  .mobile-only-button {
    display: none !important;
  }

  .pagination {
    display: flex !important;
    flex-wrap: wrap !important;
    justify-content: center !important;
    align-items: center !important;
    gap: 4px !important;
    padding: 8px 0 !important;
    list-style: none !important;
    margin: 0 auto !important;
  }

  .pagination li a,
  .pagination li span {
    display: inline-flex !important;
    align-items: center !important;
    justify-content: center !important;
    min-width: 32px !important;
    height: 32px !important;
    padding: 0 6px !important;
    border-radius: 4px !important;
    font-size: 13px !important;
    white-space: nowrap !important;
    cursor: pointer !important;
  }


  @media only screen and (max-width: 768px) {
    .mobile-only-button {
      display: inline-flex !important;
    }

    .pagination {
      gap: 3px !important;
    }

    .pagination li a,
    .pagination li span {
      min-width: 28px !important;
      height: 28px !important;
      font-size: 12px !important;
      padding: 0 5px !important;
    }

    .lead-card {
      padding: 12px !important;
    }

    .lead-card h3 {
      font-size: 1rem !important;
    }

    .lead-card table td {
      display: block !important;
      width: 100% !important;
      padding: 4px 0 !important;
      border: none !important;
      font-size: 13px !important;
    }

    .lead-card table tr {
      display: block !important;
      margin-bottom: 6px !important;
    }

    .chakra-table__container {
      overflow-x: hidden !important;
    }
  }
`;
export default function FollowUp() {
  const [mainPage, setMainPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().split('T')[0],
  );
  const [searchTerm, setSearchTerm] = useState('');
  const [updateId, setUpdateId] = useState('');
  const [updateModal, setUpdateModal] = useState(false);
  const [isWhatsappModalOpen, setIsWhatsappModalOpen] = useState(false);
  const [selectedMobileNumber, setSelectedMobileNumber] = useState('');
  const [selectedLeadName, setSelectedLeadName] = useState('');
  const [whatsappDropdownSelection, setWhatsappDropdownSelection] =
    useState('');
  const [whatsAppMessage, setWhatsAppMessage] = useState([]);
  const [otherMessage, setOtherMessage] = useState('');
  const [leadStatuses, setLeadStatuses] = useState([]);
  const [errors, setErrors] = useState({ dropdown: '', other: '' });
  const [searchDefault, setSearchDefault] = useState({
    page: '',
    search: '',
    startDate: '',
    endDate: '',
    status: '',
    managerId: '', // Add managerId to searchDefault
  });

  const [leadId, setLeadId] = useState([]);
  const [checked, setChecked] = useState(false);
  const [bulkUpdateModal, setBulkUpdateModal] = useState(false);
  const [bulkFollowUpDate, setBulkFollowUpDate] = useState('');
  const [isBulkLoading, setIsBulkLoading] = useState(false);

  const dispatch = useDispatch();
  const getFollowups = useSelector((state) => state.files);
  const setting = useSelector((state) => state.setting);
  const managers = getFollowups?.allCounselor?.data?.CounselorsData || []; // Add managers from redux state

  const ChangeMainPage = (selected) => {
    setMainPage(parseInt(selected.selected) + 1);
  };

  const handleRowsPerPageChange = (e) => {
    const newRowsPerPage = parseInt(e.target.value, 10);
    setRowsPerPage(newRowsPerPage);
    setMainPage(1);
  };

  const postPerPage = rowsPerPage;
  const PageCount = Math.ceil(
    getFollowups?.getFollowup?.data?.totalPatients / postPerPage,
  );

  useEffect(() => {
    dispatch(getSetting());
  }, []);

  useEffect(() => {
    if (
      Array.isArray(setting?.getSetting?.leadStatuses?.leadStatuses) &&
      setting?.getSetting?.leadStatuses?.leadStatuses.length > 0
    ) {
      setLeadStatuses(setting.getSetting.leadStatuses?.leadStatuses || []);
    }
  }, [setting]);
  useEffect(() => {
    const queryParams = {
      page: mainPage,
      limit: rowsPerPage,
      date: selectedDate,
      search: searchTerm.trim(),
      managerId: searchDefault.managerId, // Pass managerId from searchDefault
    };
    dispatch(getFollowup(queryParams));
  }, [
    mainPage,
    rowsPerPage,
    selectedDate,
    searchTerm,
    searchDefault.managerId,
  ]);

  const handleDateChange = (e) => {
    setSelectedDate(e.target.value);
  };

  const updateToggle = (id) => {
    setUpdateModal(!updateModal);
    dispatch(viewLead(id));
    if (!updateModal) {
      setUpdateId(id);
    } else {
      setUpdateId('');
    }
  };

  const openWhatsappModal = (mobileNumber, firstName, lastName) => {
    setIsWhatsappModalOpen(true);
    setSelectedMobileNumber(mobileNumber);
    setSelectedLeadName(`${firstName} ${lastName}`);
  };

  const closeWhatsappModal = () => {
    setIsWhatsappModalOpen(false);
    setWhatsappDropdownSelection('');
    setOtherMessage('');
    setErrors({ dropdown: '', other: '' });
  };

  const handleSend = () => {
    let hasError = false;
    const newErrors = { dropdown: '', other: '' };

    if (!whatsappDropdownSelection) {
      newErrors.dropdown = 'Please select a message option.';
      hasError = true;
    }

    if (whatsappDropdownSelection === 'other' && !otherMessage.trim()) {
      newErrors.other = 'Please enter your custom message.';
      hasError = true;
    }

    setErrors(newErrors);
    if (hasError) return;

    let formattedNumber = selectedMobileNumber;
    // if (!formattedNumber.startsWith('91')) {
    //   formattedNumber = `91${formattedNumber}`;
    // }

    let messageToSend = '';
    if (whatsappDropdownSelection === 'other') {
      messageToSend = otherMessage;
      setOtherMessage('');
    } else {
      const selectedMsgObj = whatsAppMessage.find(
        (msg) => msg._id === whatsappDropdownSelection,
      );
      messageToSend = selectedMsgObj?.description || '';
      setOtherMessage('');
    }

    const encodedMessage = encodeURIComponent(messageToSend);
    const whatsappURL = `https://web.whatsapp.com/send?phone=${formattedNumber}&text=${encodedMessage}`;

    window.open(whatsappURL, '_blank');
    closeWhatsappModal();
  };
  const getBackgroundColor = (leadStatusName) => {
    const status = leadStatuses.find(
      (status) => status.title.toLowerCase() === leadStatusName.toLowerCase(),
    );

    return status ? status.backgroundColor : 'transparent';
  };
  useEffect(() => {
    dispatch(getMessage())
      .then((res) => {
        if (res?.status === 200) {
          setWhatsAppMessage(res?.data?.data || []);
        }
      })
      .catch((err) => {
        console.error(err);
      });
  }, []);
  const formatTime = (dateString) => {
    const date = new Date(dateString);
    let hours = date.getUTCHours();
    const minutes = date.getUTCMinutes();
    const ampm = hours >= 12 ? 'PM' : 'AM';

    hours = hours % 12;
    hours = hours || 12;
    const minutesFormatted = minutes < 10 ? '0' + minutes : minutes;

    return `${hours}:${minutesFormatted} ${ampm}`;
  };
  const handlePhoneClick = (phoneNumber) => {
    window.location.href = `tel:${phoneNumber}`;
  };
  const handleManagerChange = (e) => {
    const managerId = e.target.value;
    setSearchDefault((prev) => ({
      ...prev,
      managerId: managerId,
    }));
  };

  const handleCheckboxChange = (e, id) => {
    setLeadId((prev) => {
      const updated = e.target.checked
        ? [...prev, id]
        : prev.filter((lead) => lead !== id);
      setChecked(updated.length > 0);
      return updated;
    });
  };

  return (
    <>
      <style>{responsiveStyles}</style>
      <div className="mt-[100px]">
        {/* <div className="d-flex justify-between items-center gap-3"> */}
        <div className="d-flex flex-column flex-md-row flex-wrap gap-3">
          <div className="">
            <label className="text-sm">Select Date</label>
            {/* <input
              type="date"
              name="startDate"
              value={selectedDate}
              onChange={handleDateChange}
              className="w-75 outline-none !border-b"
            /> */}
            <input
              type="date"
              name="startDate"
              value={selectedDate}
              onChange={handleDateChange}
              className="w-100 outline-none !border-b"
            />
          </div>
          {/* Add Manager Filter */}
          {localStorage.getItem('type') !== 'Manager' && (
            <div className="">
              <label className="text-sm block mb-1">Manager</label>
              <select
                onChange={handleManagerChange}
                value={searchDefault.managerId || ''}
                className="w-100 border-b outline-none bg-transparent"
              >
                <option value="">Select Manager</option>
                {managers.map((manager) => (
                  <option key={manager._id} value={manager._id}>
                    {manager.name}
                  </option>
                ))}
              </select>
            </div>
          )}
          {/* <div className="bg-white shadow-shadows py-[8px] px-[20px] rounded-full flex items-center gap-2 me-2 ms-auto"> */}
          <div className="bg-white shadow-shadows py-[8px] px-[20px] rounded-full flex items-center gap-2 w-100 w-md-auto">
            <IoSearchOutline />
            <input
              type="text"
              name="search"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="w-full outline-none"
              placeholder="Search..."
            />
          </div>
        </div>
      </div>
      <div className="mt-[50px] mb-4">
        {/* <div className="mb-3 flex items-center justify-between mt-5"> */}
        <div className="mb-3 d-flex flex-column flex-md-row align-items-start align-items-md-center justify-content-between mt-5 gap-2">
          {/* <h3 className="fw-bold">Today Followup</h3> */}
          {/* <div className="mb-3 flex items-center justify-between mt-5 flex-wrap gap-2"> */}
          <div className="mb-3 d-flex align-items-center justify-content-between flex-wrap gap-2 w-100">
            <h3 className="fw-bold">Today Followup</h3>

            {checked && (
              <Button
                onClick={() => setBulkUpdateModal(true)}
                className="!bg-theme-dark fw-bold d-flex align-items-center border-0 justify-content-center"
              >
                <FaRegClock className="me-2" />
                Set Follow-Up ({leadId.length})
              </Button>
            )}
          </div>
          <div className="ms-auto border-r pe-3 me-3">
            Total Records:{' '}
            <span className="text-success border-b border-success">
              {getFollowups?.getFollowup?.data?.totalPatients || 0}
            </span>
          </div>
          <div>
            Rows per page:
            <select
              value={rowsPerPage}
              onChange={handleRowsPerPageChange}
              className="ms-2 border rounded-md focus:outline-none"
            >
              <option value={10}>10</option>
              <option value={30}>30</option>
              <option value={50}>50</option>
              <option value={100}>100</option>
              <option value={500}>500</option>
            </select>
          </div>
        </div>

        {getFollowups?.getFollowup?.data?.data?.length > 0 && (
          <div className="d-flex align-items-center w-40 justify-content-between bg-light rounded px-3 py-2 mb-3 border">
            <div className="d-flex align-items-center gap-2">
              <input
                type="checkbox"
                className="accent-theme-dark w-[16px] h-[16px] cursor-pointer"
                checked={
                  getFollowups.getFollowup.data.data.length > 0 &&
                  getFollowups.getFollowup.data.data.every((r) =>
                    leadId.includes(r._id),
                  )
                }
                onChange={(e) => {
                  if (e.target.checked) {
                    const allIds = getFollowups.getFollowup.data.data.map(
                      (r) => r._id,
                    );
                    setLeadId(allIds);
                    setChecked(true);
                  } else {
                    setLeadId([]);
                    setChecked(false);
                  }
                }}
              />
              <span className="text-sm fw-medium">
                {leadId.length > 0
                  ? `${leadId.length} lead(s) selected`
                  : 'Select All'}
              </span>
            </div>
            {leadId.length > 0 && (
              <button
                className="text-sm text-blue-600 underline cursor-pointer bg-transparent border-0"
                onClick={() => {
                  setLeadId([]);
                  setChecked(false);
                }}
              >
                Clear Selection
              </button>
            )}
          </div>
        )}

        <TableContainer>
          <Table variant="striped" colorScheme="blackAlpha">
            {/* <Thead>
                <Tr>
                  <Th>Next Followup Date</Th>
                  <Th>Branch</Th>
                  <Th>Phone Number</Th>
                  <Th>First Name</Th>
                  <Th>Last Name</Th>
                  <Th>Lead Status</Th>
                  <Th>Lead From</Th>
                  <Th>Gender</Th>
                  <Th>Date of Birth</Th>
                  <Th>Country</Th>
                  <Th>State</Th>
                  <Th>City</Th>
                  <Th>Area</Th>
                  <Th>Lead Received On</Th>
                  <Th>Campaign</Th>
                  <Th>Campaign Details</Th>
                  <Th>Remark</Th>
                  <Th>From</Th>
                  <Th>To</Th>
                  <Th>Nationality</Th>
                  <Th>Lead Assign</Th>
                  <Th>Occupation</Th>
                  <Th>Email</Th>
                  <Th>Address</Th>
                  <Th>Pincode</Th>
                  <Th>Lead FollowUp Remark</Th>
                  <Th>Photo</Th>
                  <Th style={{ position: 'sticky', right: 80, background: '#fff', zIndex: 2, minWidth: '50px' }}>WhatsApp</Th>
                  <Th className="phone-column" style={{ position: 'sticky', right: 42, background: '#fff', zIndex: 2, minWidth: '50px' }}>Phone</Th>

                  <Th
                    style={{
                      position: 'sticky',
                      right: 0,
                      background: '#fff',
                      zIndex: 2,
                      minWidth: '50px',
                    }}
                  >
                    Action
                  </Th>
                </Tr>
              </Thead>
              <Tbody>
                {getFollowups?.getFollowup?.data?.data?.length > 0 ? (
                  getFollowups?.getFollowup?.data?.data?.map((res) => {
                    return (
                      <Tr key={res._id}>
                        <Td>
                          {res.nextFollowUpDate
                            ? moment(res.nextFollowUpDate).format('DD/MM/YYYY')
                            : ''}
                        </Td>
                        <Td>{res.branch}</Td>
                        <Td>{res.phoneNumber}</Td>
                        <Td className="capitalize">{res.firstName}</Td>
                        <Td className="capitalize">{res.lastName}</Td>
                        <Td className="capitalize">
                          <span
                            onClick={() => {
                              updateToggle(res);
                            }}
                            className={`cursor-pointer ${
                              res.leadStatus === 'new' || res.leadStatus === 'New'
                                ? 'bg-[#198754] text-white px-3 py-1 rounded inline-block text-sm'
                                : res.leadStatus === 'close'
                                ? 'bg-[#03367f] text-white px-3 py-1 rounded inline-block text-sm'
                                : res.leadStatus === 'exit'
                                ? 'bg-[#dc3545] text-white px-3 py-1 rounded inline-block text-sm'
                                : res.leadStatus === 'pending'
                                ? 'bg-[#ffc107] text-black px-3 py-1 rounded inline-block text-sm'
                                : res.leadStatus === 'pipeline'
                                ? 'bg-[#0dcaf0] text-white px-3 py-1 rounded inline-block text-sm'
                                : res.leadStatus === 'inProcess'
                                ? 'bg-[#fd7e14] text-white px-3 py-1 rounded inline-block text-sm'
                                : res.leadStatus === 'counsultation done'
                                ? 'bg-[#6c757d] text-white px-3 py-1 rounded inline-block text-sm'
                                : 'bg-transparent text-black'
                            }`}
                          >
                            {res.leadStatus}
                          </span>
                        </Td>
                        <Td>{res.leadFrom}</Td>
                        <Td>{res.gender}</Td>
                        <Td>
                          {res.dateOfBirth
                            ? moment(res.dateOfBirth).format('DD/MM/YYYY')
                            : ''}
                        </Td>
                        <Td>{res.country}</Td>
                        <Td>{res.state}</Td>
                        <Td>{res.city}</Td>
                        <Td>{res.area}</Td>
                        <Td>{res.leadReceived}</Td>
                        <Td>{res?.campaign[0]?.cname}</Td>
                        <Td>{res?.campaign[0]?.description}</Td>
                        <Td>{res.remark}</Td>
                        <Td>
                          {res.from
                            ? new Date(res.from).toLocaleTimeString()
                            : ''}
                        </Td>
                        <Td>
                          {res.to ? new Date(res.to).toLocaleTimeString() : ''}
                        </Td>
                        <Td>{res.nationality}</Td>
                        <Td>{res.counselorAssignName}</Td>
                        <Td>{res.occupation}</Td>
                        <Td>{res.email}</Td>
                        <Td>{res.address}</Td>
                        <Td>{res.pincode}</Td>
                        <Td>{res.leadFollowUpRemark}</Td>
                        <Td>
                          <img
                            src={res.photo || userPhoto}
                            alt="user photo"
                            className="w-[60px]"
                          />
                        </Td>
                        <Td style={{ position: 'sticky', right: 80, background: '#fff', zIndex: 2, textAlign: 'center' }}>
                          <div className="d-flex gap-2 fs-6 fw-bold" onClick={() => openWhatsappModal(res.phoneNumber, res.firstName, res.lastName)}>
                            <MdWhatsapp className="text-success" size={30}/>
                          </div>
                        </Td>
                        <Td className="phone-column" style={{ position: 'sticky', right: 42, background: 'inherit', zIndex: 2 }}>
                          <button
                            onClick={() => handlePhoneClick(res.phoneNumber)}
                            className="btn btn-link p-0 text-primary"
                          >
                            <FaPhone size={25} />
                          </button>
                        </Td>
                        <Td
                          style={{
                            position: 'sticky',
                            right: 0,
                            background: '#fff',
                            zIndex: 1,
                          }}
                        >
                          <div
                            onClick={() => {
                              updateToggle(res);
                            }}
                            className="d-flex gap-2 fs-6 fw-bold"
                          >
                            <FaEdit className="text-success" />
                            Edit
                          </div>
                        </Td>
                      </Tr> 
                    );
                  })
                ) : (
                  <Tr>
                    <Td colSpan="32">Today no any followup</Td>
                  </Tr>
                )}
              </Tbody> */}
            {getFollowups?.getFollowup?.data?.data?.length > 0 ? (
              getFollowups?.getFollowup?.data?.data?.map((res) => (
                <div
                  key={res._id}
                  className={`lead-card mb-4 bg-white rounded-lg shadow p-4 transition-all ${
                    leadId.includes(res._id)
                      ? 'border-2 border-blue-500'
                      : 'border border-transparent'
                  }`}
                >
                  <div className="flex items-center gap-2 mb-2">
                    <input
                      type="checkbox"
                      className="accent-theme-dark w-[16px] h-[16px] cursor-pointer"
                      checked={leadId.includes(res._id)}
                      onChange={(e) => handleCheckboxChange(e, res._id)}
                    />
                    <span className="text-xs text-gray-400">
                      Select for bulk update
                    </span>
                  </div>
                  <h3
                    className="text-xl font-medium mb-3 text-blue-900  cursor-pointer hover:underline"
                    onClick={() => updateToggle(res)}
                  >
                    <FaUser
                      className="inline-block mr-2 text-blue-900"
                      size="18px"
                    />
                    {res.firstName} {res.lastName}
                  </h3>

                  <TableContainer>
                    <Table variant="simple">
                      <Tbody>
                        <Tr>
                          <Td fontWeight="bold" py="1" lineHeight="short">
                            <FaWpforms className="inline-block mr-2 text-blue-500" />
                            Lead Status:&nbsp;&nbsp;
                            <button
                              disabled={
                                localStorage
                                  .getItem('type')
                                  ?.toLowerCase()
                                  .trim() === 'lead'
                              }
                              onClick={() => updateToggle(res)}
                              style={{
                                background: res.leadStatus
                                  ? getBackgroundColor(
                                      res.leadStatus.trim().toLowerCase(),
                                    )
                                  : 'transparent',
                                color: res.leadStatus ? 'white' : 'black',
                              }}
                              className="cursor-pointer px-2 py-0.5 rounded"
                            >
                              {res.leadStatus}
                            </button>
                            {/* <FaWpforms className="inline-block mr-2 text-blue-500" />
                          Lead Status:&nbsp;&nbsp;
                          <span
                            onClick={() => {
                              updateToggle(res);
                            }}
                            className={`cursor-pointer ${res.leadStatus === 'new' || res.leadStatus === 'New'
                              ? 'bg-[#198754] text-white px-3 py-1 rounded inline-block text-sm'
                              : res.leadStatus === 'close'
                                ? 'bg-[#03367f] text-white px-3 py-1 rounded inline-block text-sm'
                                : res.leadStatus === 'exit'
                                  ? 'bg-[#dc3545] text-white px-3 py-1 rounded inline-block text-sm'
                                  : res.leadStatus === 'pending'
                                    ? 'bg-[#ffc107] text-black px-3 py-1 rounded inline-block text-sm'
                                    : res.leadStatus === 'pipeline'
                                      ? 'bg-[#0dcaf0] text-white px-3 py-1 rounded inline-block text-sm'
                                      : res.leadStatus === 'inProcess'
                                        ? 'bg-[#fd7e14] text-white px-3 py-1 rounded inline-block text-sm'
                                        : res.leadStatus === 'counsultation done'
                                          ? 'bg-[#6c757d] text-white px-3 py-1 rounded inline-block text-sm'
                                          : 'bg-transparent text-black'
                              }`}
                          >
                            {res.leadStatus}
                          </span> */}
                          </Td>
                          <Td fontWeight="bold" py="1" lineHeight="short">
                            <MdDateRange className="inline-block mr-2 text-green-500" />
                            Next Followup Date:&nbsp;&nbsp;
                            <span style={{ fontWeight: 'normal' }}>
                              {res.nextFollowUpDate
                                ? moment(res.nextFollowUpDate).format(
                                    'DD/MM/YYYY',
                                  )
                                : ''}
                            </span>
                          </Td>
                          <Td fontWeight="bold" py="1" lineHeight="short">
                            <FaRegClock className="inline-block  mr-2  text-orange-500" />
                            Time:&nbsp;&nbsp;
                            <span style={{ fontWeight: 'normal' }}>
                              {res.createdAt ? formatTime(res.createdAt) : ''}
                            </span>
                          </Td>
                          {/* <Td w="50px" py="1">
                            <div className="d-flex gap-3"> */}
                          <Td py="1" colSpan={3}>
                            <div className="d-flex flex-wrap gap-3">
                              {/* <button
                                className="text-primary"
                                onClick={() => handlePhoneClick(res.phoneNumber)}
                                title="Call"
                              >
                                <FaPhone size={18} />
                              </button> */}
                              <button
                                className="text-green-500 hover:text-green-700"
                                onClick={() =>
                                  openWhatsappModal(
                                    res.phoneNumber,
                                    res.firstName,
                                    res.lastName,
                                  )
                                }
                                title="WhatsApp"
                              >
                                <MdWhatsapp size={28} />
                              </button>
                              {/* <button className="text-blue-500" onClick={() => handleView(res._id)} title="View">
                              <FiTarget size={28} />
                            </button> */}
                              <button
                                className="text-success"
                                onClick={() => updateToggle(res)}
                                title="Edit"
                              >
                                <FaEdit size={28} />
                              </button>
                              {/* <button className="text-red-500" onClick={() => deleteData(res._id)} title="Delete">
                              <MdDelete size={28} />
                            </button> */}
                            </div>
                          </Td>
                        </Tr>

                        <Tr sx={{ borderBottom: 'none' }}>
                          <Td fontWeight="bold" py="1">
                            <FiTarget className="inline-block  mr-2  text-purple-500" />
                            Lead From:&nbsp;&nbsp;
                            <span style={{ fontWeight: 'normal' }}>
                              {res.leadFrom}
                            </span>
                          </Td>
                          <Td fontWeight="bold" py="1">
                            <FaPhone className="inline-block  mr-2  text-blue-500" />
                            Phone:&nbsp;&nbsp;
                            <span style={{ fontWeight: 'normal' }}>
                              {res.phoneNumber}
                            </span>
                          </Td>
                          <Td fontWeight="bold" py="1">
                            <MdLocationOn className="inline-block  mr-2  text-red-500" />
                            Location:&nbsp;&nbsp;
                            <span style={{ fontWeight: 'normal' }}>
                              {res.city
                                ? `${res.city}, ${res.country || ''}`
                                : 'N/A'}
                            </span>
                          </Td>

                          <Td colSpan={2}></Td>
                        </Tr>

                        <Tr sx={{ borderBottom: 'none' }}>
                          <Td fontWeight="bold" py="1">
                            <MdComment className="inline-block  mr-2  text-gray-500" />
                            Remark:&nbsp;&nbsp;
                            <span
                              style={{
                                fontWeight: 'normal',
                                display: 'contents',
                                maxWidth: '300px',
                                whiteSpace: 'pre-wrap',
                                wordBreak: 'break-word',
                              }}
                            >
                              {res.remark}
                            </span>
                          </Td>
                          <Td fontWeight="bold" py="1">
                            <MdLocationOn className="inline-block mr-2 text-blue-500" />
                            Branch:&nbsp;&nbsp;
                            <span style={{ fontWeight: 'normal' }}>
                              {res.branch}
                            </span>
                          </Td>
                          <Td fontWeight="bold" py="1">
                            <FaCalendarPlus className="inline-block mr-2 text-purple-500" />
                            Lead Received:&nbsp;&nbsp;
                            <span style={{ fontWeight: 'normal' }}>
                              {res.leadReceived}
                            </span>
                          </Td>
                        </Tr>
                        <Tr>
                          <Td fontWeight="bold" py="1">
                            <MdCampaign className="inline-block mr-2 text-blue-500" />
                            Campaign:&nbsp;&nbsp;
                            <span style={{ fontWeight: 'normal' }}>
                              {res?.campaign[0]?.cname}
                            </span>
                          </Td>
                          <Td fontWeight="bold" py="1">
                            <MdDescription className="inline-block mr-2 text-gray-500" />
                            Campaign Details:&nbsp;&nbsp;
                            <span style={{ fontWeight: 'normal' }}>
                              {res?.campaign[0]?.description}
                            </span>
                          </Td>
                          <Td fontWeight="bold" py="1">
                            <FaUser className="inline-block mr-2 text-green-500" />
                            Lead Assign:&nbsp;&nbsp;
                            <span style={{ fontWeight: 'normal' }}>
                              {res?.counselorAssign?.name || '-'}
                            </span>
                          </Td>
                        </Tr>
                        <Tr>
                          <button
                            className="mobile-only-button py-[8px] px-[20px] rounded-full !bg-theme-dark fw-bold d-flex align-item-center border-0 text-white mt-2 ml-5"
                            onClick={() => handlePhoneClick(res.phoneNumber)}
                            title="Call"
                          >
                            <FaPhone size={18} className="mr-5 mt-1" /> call
                          </button>
                        </Tr>
                      </Tbody>
                    </Table>
                  </TableContainer>
                </div>
              ))
            ) : (
              <div className="text-center py-4 w-full">
                <p className="text-gray-500 font-medium">
                  Today no any followup
                </p>
              </div>
            )}
          </Table>
        </TableContainer>
      </div>
      {/* <ReactPaginate
        breakLabel="..."
        nextLabel="next >"
        onPageChange={ChangeMainPage}
        pageRangeDisplayed={5}
        pageCount={PageCount}
        previousLabel="< previous"
        renderOnZeroPageCount={null}
        className="pagination"
      /> */}
      <ReactPaginate
        breakLabel="..."
        nextLabel="next >"
        onPageChange={ChangeMainPage}
        pageRangeDisplayed={3}
        marginPagesDisplayed={1}
        pageCount={PageCount}
        previousLabel="< prev"
        renderOnZeroPageCount={null}
        className="pagination"
      />
      <FileUpdate
        updateModal={updateModal}
        updateToggle={updateToggle}
        updateId={updateId}
        searchDefault1={searchDefault}
      />

      <Modal show={isWhatsappModalOpen} onHide={closeWhatsappModal}>
        <Modal.Header closeButton>
          <Modal.Title>Send WhatsApp Message</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Form>
            <div className="mb-4">
              <Form.Label className="fw-bold text-dark">Lead Name</Form.Label>
              <Form.Control
                type="text"
                readOnly
                disabled
                value={selectedLeadName}
                className="bg-light border-0 fw-bold text-dark"
                style={{ fontSize: '1.1rem' }}
              />
            </div>

            <div className="mb-4">
              <Form.Label className="fw-bold text-dark">
                Mobile Number
              </Form.Label>
              <Form.Control
                type="text"
                readOnly
                disabled
                value={selectedMobileNumber}
                className="bg-light border-0 fw-bold text-dark"
                style={{ fontSize: '1.1rem' }}
              />
            </div>

            <div className="mb-4">
              <Form.Label className="fw-bold text-dark">
                Select Message
              </Form.Label>
              <Form.Select
                className="border-2"
                value={whatsappDropdownSelection}
                onChange={(e) => {
                  setWhatsappDropdownSelection(e.target.value);
                  setErrors((prev) => ({ ...prev, dropdown: '' }));
                }}
              >
                <option value="">Select Option</option>
                {whatsAppMessage.map((msg) => (
                  <option key={msg._id} value={msg._id}>
                    {msg.title}
                  </option>
                ))}
                <option value="other">Other</option>
              </Form.Select>
              {errors.dropdown && (
                <div
                  className="text-danger mt-1"
                  style={{ fontSize: '0.875rem' }}
                >
                  {errors.dropdown}
                </div>
              )}
            </div>

            {whatsappDropdownSelection === 'other' && (
              <div className="mb-4">
                <Form.Control
                  type="text"
                  placeholder="Please specify"
                  className="border-2"
                  value={otherMessage}
                  onChange={(e) => {
                    setOtherMessage(e.target.value);
                    setErrors((prev) => ({ ...prev, other: '' }));
                  }}
                />
                {errors.other && (
                  <div
                    className="text-danger mt-1"
                    style={{ fontSize: '0.875rem' }}
                  >
                    {errors.other}
                  </div>
                )}
              </div>
            )}
          </Form>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={closeWhatsappModal}>
            Cancel
          </Button>
          <Button className="!bg-theme-dark border-0 px-4" onClick={handleSend}>
            Send
          </Button>
        </Modal.Footer>
      </Modal>

      {/* ── Bulk Follow-Up Date Modal ── */}
      <Modal
        show={bulkUpdateModal}
        onHide={() => {
          setBulkUpdateModal(false);
          setBulkFollowUpDate('');
        }}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <FaRegClock className="inline-block me-2 text-blue-600" />
            Set Follow-Up Date
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="mb-3 bg-blue-50 border border-blue-200 rounded p-3 text-sm text-blue-800">
            This will set the same follow-up date for{' '}
            <strong>{leadId.length} selected lead(s)</strong>.
          </div>
          <Form.Group>
            <Form.Label className="fw-bold">
              Next Follow-Up Date <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              type="date"
              value={bulkFollowUpDate}
              min={new Date().toISOString().split('T')[0]}
              onChange={(e) => setBulkFollowUpDate(e.target.value)}
              className="shadow-none"
            />
            {!bulkFollowUpDate && (
              <Form.Text className="text-muted">
                Please select a date to continue.
              </Form.Text>
            )}
          </Form.Group>
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              setBulkUpdateModal(false);
              setBulkFollowUpDate('');
            }}
          >
            Cancel
          </Button>
          <Button
            className="!bg-theme-dark border-0 px-4 d-flex align-items-center gap-2"
            disabled={!bulkFollowUpDate || isBulkLoading}
            onClick={async () => {
              if (!bulkFollowUpDate) return;
              setIsBulkLoading(true);
              try {
                const updatePromises = leadId.map((id) => {
                  const formData = new FormData();
                  formData.append('patientId', id);
                  formData.append('nextFollowUpDate', bulkFollowUpDate);
                  return dispatch(
                    updateLead(
                      formData,
                      { page: mainPage, limit: rowsPerPage },
                      '',
                      {
                        page: mainPage,
                        limit: rowsPerPage,
                        date: selectedDate,
                      },
                    ),
                  );
                });

                await Promise.all(updatePromises);

                toast.success(
                  `Follow-up date updated for ${leadId.length} lead(s) successfully!`,
                );

                // Reset everything
                setBulkUpdateModal(false);
                setBulkFollowUpDate('');
                setLeadId([]);
                setChecked(false);

                // Refresh the followup list
                dispatch(
                  getFollowup({
                    page: mainPage,
                    limit: rowsPerPage,
                    date: selectedDate,
                    search: searchTerm.trim(),
                    managerId: searchDefault.managerId,
                  }),
                );
              } catch (error) {
                console.error('Bulk update error:', error);
                toast.error(
                  error?.response?.data?.message ||
                    'Failed to update follow-up dates.',
                );
              } finally {
                setIsBulkLoading(false);
              }
            }}
          >
            {isBulkLoading ? (
              <>
                <span
                  className="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                />
                Updating...
              </>
            ) : (
              <>
                <FaRegClock />
                Update {leadId.length} Lead(s)
              </>
            )}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
